import React from 'react';
import { FormHorizontal } from '~/components/form/layout';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { DemoBrochuresOptionId } from '~/tenants/demo/performable/brochures/DemoBrochuresConfig';
import { DEMO_BROCHURES_OPTIONS } from '~/tenants/demo/performable/brochures/DemoBrochuresJob';
import { DemoOrderContext } from '~/tenants/demo/model/DemoOrder';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingle } from '~/components/zod/ZodForm';
import { TenantPerformableConfiguration } from '~/tenants/common/performable';

export default function DemoBrochuresForm(_props: TenantPerformableFormProps<DemoOrderContext>) {
  const [_optionName, option] = useZodFormFieldSingle<DemoBrochuresOptionId>('option');

  let quantity = <></>;

  if (option) {
    const pkg = DEMO_BROCHURES_OPTIONS[option];
    quantity = (
      <FormHorizontal name="quantity" label="Quantity">
        <ZodFieldSelect
          name="quantity"
          options={Object.entries(pkg.revenue).map(([id, pkg]) => ({
            value: id,
            label: id,
          }))}
        />
      </FormHorizontal>
    );
  }

  return (
    <TenantPerformableConfiguration>
      <FormHorizontal name="option" label="Size">
        <ZodFieldSelect
          name="option"
          options={Object.entries(DEMO_BROCHURES_OPTIONS).map(([id, pkg]) => ({
            value: id,
            label: `${pkg.pages} Pages (${pkg.width} x ${pkg.height})`,
          }))}
        />
      </FormHorizontal>

      {quantity}
    </TenantPerformableConfiguration>
  );
}
